<template>
  <div class="home mb-12">
    <div
      class="hero h-[280px] pt-[192px] md:pt-[172px] lg:pt-[324px] lg:h-[480px] bg-darkblue/20"
    >
      <base-section
        class="w-full bg-darkblue/70 pt-2 pb-2 px-1 md:px-4 text-white"
      >
        <base-card class="">
          <base-card-section
            class="flex justify-between items-center px-1 lg:px-4 lg:py-2"
          >
            <div
              class="flex flex-col justify-start text-base sm:text-md md:text-xl lg:text-[38px] font-bold md:leading-8 lg:leading-[44px] tracking-tight"
            >
              <p>VIP SERVICE</p>
              <p class="text-active">
                <span v-if="width > 270">ACTIVE</span> {{ activeVipDate }}
              </p>
              <p class="text-base sm:text-md md:text-lg lg:text-3xl">
                <span v-if="width > breakpoint.sm">AVAILABLE</span> UNTIL
                {{ activeVipTime }}
              </p>
            </div>
            <div
              class="flex flex-col lg:justify-start text-base sm:text-md md:text-xl lg:text-3xl font-bold tracking-tight text-center"
            >
              <p v-if="currentInsidersLive.length > 0" class="text-active">
                <span v-if="width > breakpoint.sm">UPCOMING</span> INSIDERS
              </p>
              <p
                v-for="(ins, idx) in currentInsidersLive.slice(0, 2)"
                :key="idx"
              >
                {{ ins.date }}
              </p>
            </div>
          </base-card-section>
        </base-card>
      </base-section>
    </div>

    <base-section class="p-2 lg:p-4">
      <div
        class="flex items-center lg:justify-between justify-center w-full pb-4 flex-wrap"
      >
        <base-image
          fit="contain"
          class="lg:w-1/6 flex justify-center w-[77.5px] h-[28px] sm:w-[155px] sm:h-[56px]"
          :src="require('../assets/PayPal.webp')"
        ></base-image>
        <base-image
          fit="contain"
          class="lg:w-1/6 flex justify-center w-[77.5px] h-[28px] sm:w-[155px] sm:h-[56px]"
          :src="require('../assets/skrill.webp')"
        ></base-image>
        <base-image
          fit="contain"
          class="lg:w-1/6 flex justify-center w-[77.5px] h-[28px] sm:w-[155px] sm:h-[56px]"
          :src="require('../assets/neteller.webp')"
        ></base-image>
        <base-image
          fit="contain"
          class="lg:w-1/6 flex justify-center w-[77.5px] h-[28px] sm:w-[155px] sm:h-[56px]"
          :src="require('../assets/bitcoin.webp')"
        ></base-image>
        <base-image
          fit="contain"
          class="lg:w-1/6 flex justify-center w-[77.5px] h-[28px] sm:w-[155px] sm:h-[56px]"
          :src="require('../assets/moneygram.webp')"
        ></base-image>
        <base-image
          fit="contain"
          class="lg:w-1/6 flex justify-center w-[77.5px] h-[28px] sm:w-[155px] sm:h-[56px]"
          :src="require('../assets/wu.webp')"
        ></base-image>
      </div>
    </base-section>

    <base-section class="px-2 py-8 lg:p-4">
      <base-card
        flat
        class="md:bg-white/30 flex flex-col p-4 items-center justify-center"
      >
        <div class="text-center">
          <h2
            v-if="true"
            class="text-2xl md:text-4xl uppercase font-bold pb-2 text-active"
          >
            Check our latest discounts
          </h2>
          <h2
            v-if="false"
            class="text-2xl md:text-4xl uppercase font-bold pb-2"
          >
            DISCOUNT ON ALL PACKAGES
          </h2>
          <h3 v-if="false" class="px-2 pb-2 text-xl md:text-2xl font-bold">
            Pay up to 20% less until 15. January
          </h3>
          <h2 v-if="true" class="text-2xl md:text-4xl uppercase font-bold pb-2">
            DON'T MISS GREAT OFFERS
            <!-- UPCOMING INSIDERS:
            <span class="text-active px-2" v-for="(ins, idx) in currentInsiders"
              >{{ ins.date }}
            </span> -->
          </h2>
          <p class="font-bold text-xl md:text-2xl">
            Contact us on:
            <span class="font-bold text-darkblue">shark1x2@hotmail.com</span>
          </p>
        </div>
        <div class="flex max-w-1/2 py-2">
          <base-banner
            class="w-1/2 pb-1 md:w-1/2 h-auto flex justify-center"
            :imgSrc="require('../assets/banners/BEST_TIP.gif')"
            :imgClass="'object-contain'"
            :to="'http://www.best-tip1x2.com/en/home.html'"
            alt="best tip"
          ></base-banner>
          <base-banner
            class="w-1/2 pb-1 md:w-1/2 h-auto flex justify-center"
            :imgSrc="require('../assets/banners/BEST_TIP.gif')"
            :imgClass="'object-contain'"
            :to="'http://www.best-tip1x2.com/en/home.html'"
            alt="best tip"
          ></base-banner>
        </div>
      </base-card>
    </base-section>

    <base-section class="px-4 pb-8 pt-4 lg:pt-16">
      <h2 class="text-3xl px-4 flex justify-center md:justify-start">
        SUBSCRIPTIONS
      </h2>
      <base-card
        class="flex flex-col md:flex-row items-center space-y-8 md:space-y-0 lg:space-x-4 xl:space-x-16 space-x-2 py-4"
      >
        <subscription-card class="md:w-1/3">
          <template #star>
            <div class="py-2 flex justify-around">
              <base-image
                width="50px"
                height="50px"
                :src="require('../assets/star.png')"
              ></base-image>
              <base-image
                width="50px"
                height="50px"
                :src="require('../assets/star.png')"
              ></base-image>
              <base-image
                width="50px"
                height="50px"
                :src="require('../assets/star.png')"
              ></base-image>
            </div>
          </template>
          <template #offer>
            <ul
              class="w-full lg:px-4 px-4 md:px-2 font-normal text-xs lg:text-sm space-y-1"
            >
              <li class="flex items-center justify-between space-x-2">
                <p>
                  15 <span v-if="width > breakpoint.sm">VIP</span> PICKS -
                  <span class="font-bold text-gray-500">50€</span
                  ><span v-if="false" class="pl-1 font-bold text-green-800"
                    >40€</span
                  >
                </p>
                <form
                  action="https://www.paypal.com/cgi-bin/webscr"
                  class="flex items-center"
                  method="post"
                  target="_top"
                >
                  <input type="hidden" name="cmd" value="_s-xclick" />
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="BSALV3MF8KEG8"
                  />
                  <input
                    type="image"
                    :src="require('../assets/paypal.png')"
                    width="80"
                    height="17"
                    border="0"
                    name="submit"
                    alt="Buy now"
                  />
                  <img
                    alt=""
                    border="0"
                    src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                    width="1"
                    height="1"
                  />
                </form>
              </li>
              <li class="flex items-center justify-between space-x-2">
                <p>
                  30 <span v-if="width > breakpoint.sm">VIP</span> PICKS -
                  <span class="font-bold text-gray-500">80€</span
                  ><span v-if="false" class="pl-1 font-bold text-green-800"
                    >67€</span
                  >
                </p>
                <form
                  action="https://www.paypal.com/cgi-bin/webscr"
                  class="flex items-center"
                  method="post"
                  target="_top"
                >
                  <input type="hidden" name="cmd" value="_s-xclick" />
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="GPBV3TP23SZA6"
                  />
                  <input
                    type="image"
                    :src="require('../assets/paypal.png')"
                    width="80"
                    height="17"
                    border="0"
                    name="submit"
                    alt="Buy now"
                  />
                  <img
                    alt=""
                    border="0"
                    src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                    width="1"
                    height="1"
                  />
                </form>
              </li>
              <li class="flex items-center justify-between space-x-2">
                <p>
                  90 <span v-if="width > breakpoint.sm">VIP</span> PICKS -
                  <span class="font-bold text-gray-500">180€</span
                  ><span v-if="false" class="pl-1 font-bold text-green-800"
                    >153€</span
                  >
                </p>
                <form
                  action="https://www.paypal.com/cgi-bin/webscr"
                  class="flex items-center"
                  method="post"
                  target="_top"
                >
                  <input type="hidden" name="cmd" value="_s-xclick" />
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="JMW3QN7XYVCHJ"
                  />
                  <input
                    type="image"
                    :src="require('../assets/paypal.png')"
                    width="80"
                    height="17"
                    border="0"
                    name="submit"
                    alt="Buy now"
                  />
                  <img
                    alt=""
                    border="0"
                    src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                    width="1"
                    height="1"
                  />
                </form>
              </li>
              <li class="flex items-center justify-between space-x-2">
                <p>
                  150 <span v-if="width > breakpoint.sm">VIP</span> PICKS -
                  <span class="font-bold text-gray-500">250€</span
                  ><span v-if="false" class="pl-1 font-bold text-green-800"
                    >220€</span
                  >
                </p>
                <form
                  action="https://www.paypal.com/cgi-bin/webscr"
                  class="flex items-center"
                  method="post"
                  target="_top"
                >
                  <input type="hidden" name="cmd" value="_s-xclick" />
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="CZEDYFV777CFE"
                  />
                  <input
                    type="image"
                    :src="require('../assets/paypal.png')"
                    width="80"
                    height="17"
                    border="0"
                    name="submit"
                    alt="Buy now"
                  />
                  <img
                    alt=""
                    border="0"
                    src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                    width="1"
                    height="1"
                  />
                </form>
              </li>
            </ul>
          </template>

          <template #header> VIP PICKS </template>
          <template #stake> Stake 8.5/10 </template>
          <template #odds> Odds: Over 1.75 </template>
        </subscription-card>
        <subscription-card starred class="md:w-1/3">
          <template #star>
            <div class="py-2 flex justify-around">
              <base-image
                width="50px"
                height="50px"
                :src="require('../assets/star.png')"
              ></base-image>
              <base-image
                width="50px"
                height="50px"
                :src="require('../assets/star.png')"
              ></base-image>
              <base-image
                width="50px"
                height="50px"
                :src="require('../assets/star.png')"
              ></base-image>
              <base-image
                width="50px"
                height="50px"
                :src="require('../assets/star.png')"
              ></base-image>
              <base-image
                width="50px"
                height="50px"
                :src="require('../assets/star.png')"
              ></base-image>
            </div>
          </template>
          <template #offer>
            <ul
              class="w-full lg:px-4 px-4 md:px-2 font-normal text-xs lg:text-sm space-y-1"
            >
              <li class="flex items-center justify-between space-x-2">
                <p>
                  2 INSIDER <span v-if="width > breakpoint.sm">MATCHES</span> -
                  <span class="font-bold text-gray-500">60€</span
                  ><span v-if="false" class="pl-1 font-bold text-green-800"
                    >50€</span
                  >
                </p>
                <form
                  action="https://www.paypal.com/cgi-bin/webscr"
                  class="flex items-center"
                  method="post"
                  target="_top"
                >
                  <input type="hidden" name="cmd" value="_s-xclick" />
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="3P6S4PJSTLNXE"
                  />
                  <input type="hidden" name="currency_code" value="EUR" />
                  <input
                    type="image"
                    :src="require('../assets/paypal.png')"
                    width="80"
                    height="17"
                    border="0"
                    name="submit"
                    alt="Buy now"
                  />
                  <img
                    alt=""
                    border="0"
                    src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                    width="1"
                    height="1"
                  />
                </form>
              </li>
              <li class="flex items-center justify-between space-x-2">
                <p>
                  5 INSIDER <span v-if="width > breakpoint.sm">MATCHES</span> -
                  <span class="font-bold text-gray-500">130€</span
                  ><span v-if="false" class="pl-1 font-bold text-green-800"
                    >110€</span
                  >
                </p>
                <form
                  action="https://www.paypal.com/cgi-bin/webscr"
                  class="flex items-center"
                  method="post"
                  target="_top"
                >
                  <input type="hidden" name="cmd" value="_s-xclick" />
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="XEK9CT34ANZWU"
                  />
                  <input
                    type="image"
                    :src="require('../assets/paypal.png')"
                    width="80"
                    height="17"
                    border="0"
                    name="submit"
                    alt="Buy now"
                  />
                  <img
                    alt=""
                    border="0"
                    src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                    width="1"
                    height="1"
                  />
                </form>
              </li>
              <li class="flex items-center justify-between space-x-2">
                <p>
                  10 INSIDER <span v-if="width > breakpoint.sm">MATCHES</span> -
                  <span class="font-bold text-gray-500">190€</span
                  ><span v-if="false" class="pl-1 font-bold text-green-800"
                    >165€</span
                  >
                </p>
                <form
                  action="https://www.paypal.com/cgi-bin/webscr"
                  class="flex items-center"
                  method="post"
                  target="_top"
                >
                  <input type="hidden" name="cmd" value="_s-xclick" />
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="5K7H7ZVGKVL3G"
                  />
                  <input
                    type="image"
                    :src="require('../assets/paypal.png')"
                    width="80"
                    height="17"
                    border="0"
                    name="submit"
                    alt="Buy now"
                  />
                  <img
                    alt=""
                    border="0"
                    src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                    width="1"
                    height="1"
                  />
                </form>
              </li>
              <li class="flex items-center justify-between space-x-2">
                <p>
                  20 INSIDER <span v-if="width > breakpoint.sm">MATCHES</span> -
                  <span class="font-bold text-gray-500">300€</span
                  ><span v-if="false" class="pl-1 font-bold text-green-800"
                    >270€</span
                  >
                </p>
                <form
                  action="https://www.paypal.com/cgi-bin/webscr"
                  class="flex items-center"
                  method="post"
                  target="_top"
                >
                  <input type="hidden" name="cmd" value="_s-xclick" />
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="84ZF245HKUBJN"
                  />
                  <input
                    type="image"
                    :src="require('../assets/paypal.png')"
                    width="80"
                    height="17"
                    border="0"
                    name="submit"
                    alt="Buy now"
                  />
                  <img
                    alt=""
                    border="0"
                    src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                    width="1"
                    height="1"
                  />
                </form>
              </li>
            </ul>
          </template>

          <template #header> INSIDER MATCHES </template>
          <template #stake> Stake 9.9/10 </template>
          <template #odds> Odds: Over 2.00 </template>
        </subscription-card>
        <subscription-card class="md:w-1/3">
          <template #star>
            <div class="py-2 flex justify-around">
              <base-image
                width="50px"
                height="50px"
                :src="require('../assets/star.png')"
              ></base-image>
              <base-image
                width="50px"
                height="50px"
                :src="require('../assets/star.png')"
              ></base-image>
              <base-image
                width="50px"
                height="50px"
                :src="require('../assets/star.png')"
              ></base-image>
              <base-image
                width="50px"
                height="50px"
                :src="require('../assets/star.png')"
              ></base-image>
            </div>
          </template>
          <template #offer>
            <ul
              class="w-full lg:px-4 px-4 md:px-2 font-normal text-xs lg:text-sm space-y-1"
            >
              <li class="flex items-center justify-between space-x-2">
                <p>
                  3 <span v-if="width > breakpoint.sm">VIP</span> TICKETS -
                  <span class="font-bold text-gray-500">70€</span
                  ><span v-if="false" class="pl-1 font-bold text-green-800"
                    >65€</span
                  >
                </p>
                <form
                  action="https://www.paypal.com/cgi-bin/webscr"
                  class="flex items-center"
                  method="post"
                  target="_top"
                >
                  <input type="hidden" name="cmd" value="_s-xclick" />
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="6T232GNDNW7XL"
                  />
                  <input
                    type="image"
                    :src="require('../assets/paypal.png')"
                    width="80"
                    height="17"
                    border="0"
                    name="submit"
                    alt="Buy now"
                  />
                  <img
                    alt=""
                    border="0"
                    src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                    width="1"
                    height="1"
                  />
                </form>
              </li>
              <li class="flex items-center justify-between space-x-2">
                <p>
                  6 <span v-if="width > breakpoint.sm">VIP</span> TICKETS -
                  <span class="font-bold text-gray-500">110€</span
                  ><span v-if="false" class="pl-1 font-bold text-green-800"
                    >102€</span
                  >
                </p>
                <form
                  action="https://www.paypal.com/cgi-bin/webscr"
                  class="flex items-center"
                  method="post"
                  target="_top"
                >
                  <input type="hidden" name="cmd" value="_s-xclick" />
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="C7Z4BNLE2VZW8"
                  />
                  <input
                    type="image"
                    :src="require('../assets/paypal.png')"
                    width="80"
                    height="17"
                    border="0"
                    name="submit"
                    alt="Buy now"
                  />
                  <img
                    alt=""
                    border="0"
                    src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                    width="1"
                    height="1"
                  />
                </form>
              </li>
              <li class="flex items-center justify-between space-x-2">
                <p>
                  10 <span v-if="width > breakpoint.sm">VIP</span> TICKETS -
                  <span class="font-bold text-gray-500">170€</span
                  ><span v-if="false" class="pl-1 font-bold text-green-800"
                    >158€</span
                  >
                </p>
                <form
                  action="https://www.paypal.com/cgi-bin/webscr"
                  class="flex items-center"
                  method="post"
                  target="_top"
                >
                  <input type="hidden" name="cmd" value="_s-xclick" />
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="DD666EMRZ4AX6"
                  />
                  <input
                    type="image"
                    :src="require('../assets/paypal.png')"
                    width="80"
                    height="17"
                    border="0"
                    name="submit"
                    alt="Buy now"
                  />
                  <img
                    alt=""
                    border="0"
                    src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                    width="1"
                    height="1"
                  />
                </form>
              </li>
              <li class="flex items-center justify-between space-x-2">
                <p>Contact for more details</p>
              </li>
            </ul>
          </template>

          <template #header> VIP TICKET </template>
          <template #stake> Stake 9/10 </template>
          <template #odds> Odds: Over 3.00 </template>
        </subscription-card>
      </base-card>
    </base-section>

    <base-section class="pb-4" v-if="true">
      <h3 class="text-2xl py-4 px-4 text-center">PICKS STATISTICS</h3>
      <ArchiveStatistics />
    </base-section>

    <base-section class="px-4 py-8" v-if="false">
      <h2 class="text-3xl pb-2 pt-4 px-4">UPCOMING TICKETS</h2>
      <h2 class="text-2xl pt-2 pb-4 px-4">
        Dates:
        <span class="text-active px-2" v-for="(tck, idx) in currentTicketsLive"
          >{{ tck.date }}
        </span>
      </h2>
      <!-- <ticket-archive></ticket-archive> -->
    </base-section>

    <base-section class="px-4 py-8">
      <h2 class="text-3xl pb-2 pt-4 px-4">UPCOMING INSIDERS</h2>
      <h2 class="text-2xl pt-2 pb-4 px-4">
        Dates:
        <span class="flex flex-wrap">
          <span
            class="text-active px-2"
            v-for="(ins, idx) in currentInsidersLive"
          >
            {{ ins.date }}
          </span></span
        >
      </h2>

      <insider-proof-archive></insider-proof-archive>
    </base-section>

    <base-section class="px-4 py-8">
      <h2 class="text-3xl py-4 px-4">INSIDER ARCHIVE</h2>
      <base-card class="overflow-hidden rounded-lg bg-white text-slate-500">
        <insider-archive></insider-archive>
      </base-card>
    </base-section>

    <base-section class="px-4 pt-12 pb-4">
      <div class="flex space-x-2 items-center pb-4">
        <!-- <base-banner
          class="w-2/6 flex justify-center"
          :imgSrc="require('../assets/banners/best-tip.gif')"
          :to="'http://www.best-tip1x2.com/'"
          alt="best-tip"
        ></base-banner>
        <base-banner
          class="w-2/6 flex justify-center"
          :imgSrc="require('../assets/banners/best-tip.gif')"
          :to="'http://www.best-tip1x2.com/'"
          alt="best-tip"
        ></base-banner> -->
        <!-- <base-banner
          class="w-2/6 flex justify-center"
          :imgSrc="require('../assets/banners/england-picks.gif')"
          :to="'https://www.englandpicks.com/'"
          alt="englandpicks"
        ></base-banner> -->
      </div>
    </base-section>

    <base-section class="p-4">
      <h2 class="text-3xl py-4 px-4">VIP PICKS ARCHIVE</h2>
      <base-card class="overflow-hidden rounded-lg bg-white text-slate-500">
        <vip-archive></vip-archive>
      </base-card>
    </base-section>

    <base-section class="px-4 pt-12 pb-4">
      <div class="flex items-center flex-wrap md:pb-4">
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/betconfirm.gif')"
          :to="'http://betconfirm.com/'"
          alt="betconfirm"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/jokerpicks.gif')"
          :to="'https://www.jokerpicks.com/'"
          alt="jokerpicks"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/picksbet.gif')"
          :to="'http://picks-bet.com/'"
          alt="picks-bet"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/navigator.gif')"
          :to="'http://navigatorbetting.com/'"
          alt="navigator-betting"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/cr7.gif')"
          :to="'http://cr7betting.com/'"
          alt="cr7 betting"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="
            require('../assets/banners/Professional-Best-Fixed-Matches-1X2.gif')
          "
          :to="'https://best-fixedmatches1x2.com/'"
          alt="best-fixedmatches1x2"
        ></base-banner>
      </div>
      <div class="flex items-center flex-wrap md:pb-4">
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/mozzart.gif')"
          :to="'https://mozzart1x2.com/'"
          alt="mozzart1x2"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/betmechanic.gif')"
          :to="'http://betmechanic.com/'"
          alt="betmechanic"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/gentlemans.gif')"
          :to="'https://gentlemans1x2.blogspot.com/'"
          alt="gentlemans bet"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/england-picks.gif')"
          :to="'https://www.englandpicks.com/'"
          alt="englandpicks"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/norway-tips.gif')"
          :to="'https://norway-tips.com/'"
          alt="norway tips"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/arrowbet.gif')"
          :to="'https://www.arrowbets.com/'"
          alt="arrowbets"
        ></base-banner>
      </div>
    </base-section>

    <base-section class="px-4 pt-12 pb-4">
      <FreeCurrent />
    </base-section>

    <base-section class="px-4 pt-12 pb-4">
      <div class="flex items-center flex-wrap md:pb-4">
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 h-auto flex justify-center"
          :imgSrc="require('../assets/banners/highstake.gif')"
          :imgClass="'object-contain'"
          :to="'https://www.highstakeclub.com/'"
          alt="highstakeclub"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/supersport2333.gif')"
          :to="'https://supersport23.beepworld.de/'"
          alt="legendtip"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/flairbet.gif')"
          :to="'https://www.flairbet.com/'"
          alt="flairbet"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/scandinaviafixedmatches.gif')"
          :to="'https://scandinaviafixedmatches.com/'"
          alt="scandinaviafixedmatches"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/bet365-fixedgames.gif')"
          :to="'https://www.bet365-fixedgames.com/'"
          alt="bet365-fixedgames"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="
            require('../assets/banners/England-Europe-Fixed-Matches-1X2.gif')
          "
          :to="'https://england-fixed-matches.com/'"
          alt="England-Europe-1X2"
        ></base-banner>
      </div>
      <div class="flex items-center flex-wrap md:pb-4">
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 h-auto flex justify-center"
          :imgSrc="require('../assets/banners/sport-fixedmatches1x2.gif')"
          :to="'https://sport-fixedmatches1x2.com/'"
          alt="sport-fixedmatches1x2"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/besttip365.gif')"
          :to="'https://besttip365.vip/'"
          alt="best tip 365"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/englandbets.gif')"
          :to="'https://england-bets.vip/'"
          alt="england-bets"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/pro1x2win.gif')"
          :to="'https://pro1x2win.com/'"
          alt="pro1x2win.com"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/1x-Special-Banner.gif')"
          :to="'https://1xspecial.blogspot.com/'"
          alt="1xspecial"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/vip-fixed.gif')"
          :to="'https://vip-fixed1x2.win/'"
          alt="vip-fixed1x2.win"
        ></base-banner>
      </div>
      <div class="flex items-center flex-wrap md:pb-4">
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 h-auto flex justify-center"
          :imgSrc="require('../assets/banners/sure-wins.gif')"
          :to="'https://sure-wins.com/'"
          alt="sure-wins"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/viktor.gif')"
          :to="'https://tipser-viktor.beepworld.de/'"
          alt="tipser-viktor"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/orabet.gif')"
          :to="'https://orabet-bloger.com/'"
          alt="orabet"
        ></base-banner>
        <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/raul-1x2.gif')"
          :to="'https://raul-1x2.com/'"
          alt="raul-1x2"
        ></base-banner>
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/premium-1x2-banner.gif')"
          :to="'https://premium1x2.blogspot.com/'"
          alt="premium-1x2"
        ></base-banner> -->
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/bet365-fixed-matches.gif')"
          :to="'https://bet365-fixed-matches.com/'"
          alt="bet365-fixed-matches"
        ></base-banner> -->
      </div>
    </base-section>

    <base-section class="pt-8 pb-16 px-4">
      <h2 class="text-3xl py-4">FREE PICKS ARCHIVE</h2>
      <base-card class="overflow-hidden rounded-lg bg-white text-slate-500">
        <free-archive></free-archive>
      </base-card>
    </base-section>
    <base-section class="px-4 pt-4 pb-4">
      <div class="flex items-center flex-wrap md:pb-4">
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/scandinaviafixedmatches.gif')"
          :to="'https://scandinaviafixedmatches.com/'"
          alt="scandinaviafixedmatches"
        ></base-banner> -->
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/sport-fixedmatches1x2.gif')"
          :to="'https://sport-fixedmatches1x2.com/'"
          alt="sport-fixedmatches1x2"
        ></base-banner> -->
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/bet365-fixedgames.gif')"
          :to="'https://www.bet365-fixedgames.com/'"
          alt="bet365-fixedgames"
        ></base-banner> -->
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/fixedmatchescorrectscore.gif')"
          :to="'https://fixedmatchescorrectscore.com/'"
          alt="fixedmatchescorrectscore"
        ></base-banner> -->
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/england-picks.gif')"
          :to="'https://www.englandpicks.com/'"
          alt="englandpicks"
        ></base-banner> -->
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="
            require('../assets/banners/Professional-Best-Fixed-Matches-1X2.gif')
          "
          :to="'https://best-fixedmatches1x2.com/'"
          alt="best-fixedmatches1x2"
        ></base-banner> -->
      </div>

      <div class="flex items-center flex-wrap md:pb-4">
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 h-auto flex justify-center"
          :imgSrc="require('../assets/banners/realmadrid-bet1x2.gif')"
          :imgClass="'object-contain'"
          :to="'https://realmadrid-bet1x2.com/'"
          alt="realmadrid-bet1x2"
        ></base-banner> -->
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/fixedmatchescorrectscore.gif')"
          :to="'https://fixedmatchescorrectscore.com/'"
          alt="fixedmatchescorrectscore"
        ></base-banner> -->
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/maxbetfixedmatches.gif')"
          :to="'https://maxbetfixedmatches.com/'"
          alt="maxbetfixedmatches"
        ></base-banner> -->
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/europe-fixedmatches.gif')"
          :to="'https://europe-fixedmatches.com/'"
          alt="europe-fixedmatches"
        ></base-banner> -->
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/livescore-fixedmatches.gif')"
          :to="'https://livescore-fixedmatches.com/'"
          alt="livescore-fixedmatches"
        ></base-banner> -->
        <!-- <base-banner
          class="w-2/6 pb-1 md:w-1/6 flex justify-center"
          :imgSrc="require('../assets/banners/bet365-fixed-matches.gif')"
          :to="'https://bet365-fixed-matches.com/'"
          alt="bet365-fixed-matches"
        ></base-banner> -->
      </div>
    </base-section>
  </div>
</template>

<script setup>
import SubscriptionCard from "@/components/SubscriptionCard.vue";
import VipArchive from "@/components/VipArchive.vue";
import TicketArchive from "@/components/TicketArchive.vue";
import InsiderProofArchive from "@/components/InsiderProofArchive.vue";
import FreeArchive from "@/components/FreeArchive.vue";
import FreeCurrent from "@/components/FreeCurrent.vue";
import InsiderArchive from "@/components/InsiderArchive.vue";
import ArchiveStatistics from "@/components/ArchiveStatistics.vue";
import { useArchiveStore } from "@/stores/archive";
import { useConfigStore } from "@/stores/config";
import { computed, ref } from "vue";

const archiveStore = useArchiveStore();
const configStore = useConfigStore();

const activeVipDate = computed(() => archiveStore.getCurrentVip.date);
const activeVipTime = computed(() => archiveStore.getCurrentVip.time);

const currentInsiders = computed(() => archiveStore.getCurrentInsiders);

const currentTickets = computed(() => archiveStore.getCurrentTickets);

const breakpoint = computed(() => configStore.getWindowBreakpoint);
const width = computed(() => configStore.getWindowWidth);

const currentDate = computed(() => new Date());

const currentInsidersLive = computed(() => {
  return currentInsiders.value.filter((el) => {
    const d = el.date.split(".");
    const d2 = d[1] + "." + d[0] + "." + d[2];
    const date = new Date(d2);

    if (
      date.getMonth() === currentDate.value.getMonth() &&
      date.getDay() === currentDate.value.getDay() &&
      date.getFullYear() === currentDate.value.getFullYear()
    ) {
      return true;
    } else return date >= currentDate.value;
  });
});

const currentTicketsLive = computed(() => {
  return currentTickets.value.filter((el) => {
    const d = el.date.split(".");
    const d2 = d[1] + "." + d[0] + "." + d[2];
    const date = new Date(d2);

    if (
      date.getMonth() === currentDate.value.getMonth() &&
      date.getDay() === currentDate.value.getDay() &&
      date.getFullYear() === currentDate.value.getFullYear()
    ) {
      return true;
    } else return date >= currentDate.value;
  });
});
</script>

<style>
.hero {
  background-image: url("../assets/hero.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  transition: all ease-in-out 0.1s;
}
</style>
